import { render, staticRenderFns } from "./info-poptip.vue?vue&type=template&id=6320370d&scoped=true&"
import script from "./info-poptip.vue?vue&type=script&lang=js&"
export * from "./info-poptip.vue?vue&type=script&lang=js&"
import style0 from "./info-poptip.vue?vue&type=style&index=0&id=6320370d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320370d",
  null
  
)

component.options.__file = "info-poptip.vue"
export default component.exports